/**
 * Base URL for raw ``fetch`` calls that bypass the Amplify JSON client
 * (streaming + multipart endpoints). Mirrors the resolution used in
 * ``pages/Neo/index.tsx``.
 *
 * Kept in its own module so unit tests can mock it: ``import.meta`` is a
 * module-only syntax that the CommonJS Jest runtime (``@swc/jest``) refuses to
 * even load, so any test that imports a module containing it would fail to
 * compile. Isolating it here lets specs ``jest.mock("./apiBase", ...)`` without
 * touching the component under test.
 */
export const getApiBaseUrl = (): string =>
  import.meta.env?.VITE_API_GATEWAY_URL_V2 ||
  import.meta.env?.VITE_API_GATEWAY_URL ||
  "";

/** Build version, sent to Neo as UI context. Same ``import.meta`` caveat. */
export const getAppVersion = (): string | undefined =>
  import.meta.env?.VITE_APP_VERSION || undefined;
